import { Routes } from '@angular/router';
import {
  CHANGE_INITIAL_PASSWORD,
  LOGIN_PATH,
} from '../../../../../values/path';
import { ADMIN } from '../../../../../values/static-values';
import { NotLoggedInGuard } from '../../../../../../sdk/src/lib/guards/not-logged-in.guard';
import { HasNotChangedInitialPasswordGuardAdmin } from '../../../../../../sdk/src/lib/guards/has-not-changed-initial-password-admin.guard';
import { AuthGuard } from '@auth0/auth0-angular';

export const CONTENT_ROUTE: Routes = [
  {
    path: LOGIN_PATH,
    loadComponent: () =>
      import('../../components/login/login.component').then(
        (loginModule) => loginModule.LoginComponent
      ),
    canActivate: [NotLoggedInGuard],
  },
  {
    path: 'callback',
    loadComponent: () =>
      import('../../components/callback/callback.component').then(
        (callbackModule) => callbackModule.CallbackComponent
      ),
  },
  {
    path: 'migration-transition',
    loadComponent: () =>
      import(
        '../../components/migration-transition/migration-transition.component'
      ).then((migrationModule) => migrationModule.MigrationTransitionComponent),
  },
  {
    path: CHANGE_INITIAL_PASSWORD,
    loadComponent: () =>
      import(
        '../../../../../../sdk/src/lib/components/change-initial-password/change-initial-password.component'
      ).then(
        (changeInitialPasswordModule) =>
          changeInitialPasswordModule.ChangeInitialPasswordComponent
      ),
    data: { calledFor: ADMIN },
    canActivate: [HasNotChangedInitialPasswordGuardAdmin],
  },
];
